import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import MainContainer from "../../components/messages/MainContainer";
import NotAuthenticated from "../../components/NotAuthenticated";
import "./style.css";

export default function MessagesPage(){

    const [_, setTitle] = useOutletContext();
    useEffect(() => setTitle("Mensajes"), []);

    const authorized = localStorage.getItem("authorization") !== null;

    return (
        <>
            {
                authorized
                ? <MainContainer />
                : <NotAuthenticated />
            }
        </>
    );
}